function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { AvGroup } from "availity-reactstrap-validation";
import TmLabel from "./components/TmLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import TmFeedback from "./components/TmFeedback";
import TmHelpMessage from "./components/TmHelpMessage";
import CheckboxGroup from "react-checkbox-group";
import _ from "lodash";
import { Badge } from "reactstrap";
import styled from 'styled-components';
const StyledBadge = styled(Badge)`
  cursor: pointer;
  :hover {
    background-color: #10323f;
  }
`;

class TmDynamicCheckboxGroupInput extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "handleChange", selectedOptions => {
      this.props.onChange(_.map(selectedOptions, 'id'));
    });

    _defineProperty(this, "renderOptions", Checkbox => {
      return _.map(this.props.options, option => {
        return /*#__PURE__*/React.createElement("div", {
          className: `
                custom-checkbox 
                custom-control 
                ${this.props.inline ? 'custom-control-inline' : ''} 
                ${_.includes(_.map(this.props.value, 'id'), option.id) ? 'custom-control-checked' : ''}
             `,
          key: `${_.camelCase(this.props.field)}__${option.id}`
        }, /*#__PURE__*/React.createElement("label", {
          className: "custom-control-label no-error-label"
        }, /*#__PURE__*/React.createElement(Checkbox, {
          className: "custom-control-input",
          value: option
        }), " ", option.label));
      });
    });

    _defineProperty(this, "render", () => {
      const {
        options,
        value,
        resourceModal,
        toggleModal,
        ...config
      } = this.props;
      const name = !!this.props.fieldGroup ? `${this.props.fieldGroup.replace(/\w+/g, _.capitalize)}[${_.camelCase(this.props.field)}]` : _.camelCase(this.props.field);
      return /*#__PURE__*/React.createElement(AvGroup, null, /*#__PURE__*/React.createElement(TmLabel, _extends({
        className: 'no-error-label',
        value: value
      }, config)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CheckboxGroup, {
        name: name,
        value: this.props.value,
        onChange: this.handleChange
      }, Checkbox => /*#__PURE__*/React.createElement(React.Fragment, null, this.renderOptions(Checkbox))), /*#__PURE__*/React.createElement(StyledBadge, {
        color: 'info-lighten',
        className: `mr-1`,
        onClick: toggleModal
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        className: 'adjusted-svg',
        icon: faPlus
      }), " ", `${_.startCase(this.props.field)}`), resourceModal), /*#__PURE__*/React.createElement(TmFeedback, config), /*#__PURE__*/React.createElement(TmHelpMessage, config));
    });
  }

}

export default TmDynamicCheckboxGroupInput;